import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  prompt: string;
  hints?: string[];
  onSubmit: (answer: string) => void;
}

export default function FreeProductionExercise({ prompt, hints, onSubmit }: Props) {
  const { t } = useTranslation();
  const [answer, setAnswer] = useState('');

  const handleSubmit = () => {
    if (answer.trim()) onSubmit(answer.trim());
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <p className="text-lg text-gray-800 font-medium">{prompt}</p>
        <p className="text-sm text-gray-400 mt-1">{t('learning.freeHint')}</p>
      </div>

      {hints && hints.length > 0 && (
        <div className="text-center text-sm text-amber-600">
          💡 {hints[0]}
        </div>
      )}

      <div>
        <textarea
          value={answer}
          onChange={e => setAnswer(e.target.value)}
          className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-indigo-400 outline-none text-lg resize-none"
          rows={3}
          placeholder="Typ hier je antwoord..."
          autoFocus
          onKeyDown={e => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSubmit();
            }
          }}
        />
      </div>

      <button
        onClick={handleSubmit}
        disabled={!answer.trim()}
        className="w-full py-4 bg-indigo-600 text-white font-bold rounded-xl text-lg hover:bg-indigo-700 active:scale-98 transition disabled:opacity-40"
      >
        {t('learning.check')}
      </button>
    </div>
  );
}
